import { RouteType } from "types/RouteType";

/**
 * Global "access denied" route. PermissionManager.handleAuthReroute redirects
 * here (with a `reason` query param) when an authenticated user hits a route
 * they cannot access — admin-only, missing permission grant, or a page-access
 * deny rule.
 *
 * Hidden from menus; requires auth (an unauthenticated user is sent to the
 * login page instead, never here).
 */
const unauthorizedRoute: RouteType = {
  name: "Unauthorized",
  path: "/unauthorized",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Access Denied",
    },
    body: {
      component: () => import("./Unauthorized"),
      grayBackground: true,
    },
  },
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  hidden: true,
};

export default unauthorizedRoute;
